import React from "react";
import styled from "styled-components";

export default function Slide_Start_2({ show }) {
  return (
    <Container show={show}>
      <Title>Herkes gibi klişe bir photobox yapmak istemedim.</Title>
      <Subtitle>
        Ben de ilk yılımıza ilerde de bakabilmek için internetin derinliklerine
        sakladım...
      </Subtitle>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  transition: all 0.2s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  z-index: 25;
  z-index: ${(props) => (props.show ? 25 : -25)};
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
`;
const Title = styled.body`
  margin-top: 0.5rem;
  text-shadow: 0px 1px 90px #000;
  color: whitesmoke;
  font-size: 8vh;
  width: 100%;
  text-align: center;
  font-weight: 500;
`;
const Subtitle = styled.body`
  text-shadow: 0px 1px 90px #000;
  color: whitesmoke;
  font-size: 3vh;
  font-weight: 300;
  width: 100%;
  text-align: center;
  opacity: 0.8;
`;
